export const constants = {
  MODULE_NAME: "admin/users/create",
};
